import { z } from 'zod';

export const englishIqMilestoneSchema = z.object({
  canContinue: z.boolean(),
  cefr: z.string(),
  confidence: z.number(),
  elapsedSeconds: z.number().int().nonnegative(),
  markSeconds: z.number().int().positive(),
  score: z.number().int(),
  subBand: z.string(),
});

export type IEnglishIqMilestone = z.infer<typeof englishIqMilestoneSchema>;
